<div class="anexos div-expand">
  <h3>Anexos</h3>
    <div class="system-table">
      <div class="system-table-conteiner">
        <table >
          <thead>
            <tr>
              <th class="">Título</th>
              <th class="">Data</th>
              <th class="title">Arquivo</th>
              <th class=""></th>
            </tr>
          </thead>
          <tbody >
            <ng-container *ngFor="let item of data?.attachments">
              <tr >
                <td >{{item?.title}}</td>
                <td >{{item?.created_at | date: 'dd/MM/YYYY H:mm:s'}}</td>
                <td ><a class="file-name" (click)="download(item?.id, item?.name)">{{item?.name}}</a></td>
                <td >
                  <div class="btn-icon">
                    <button class="btn btn-font-icon ms-1" type="button" (click)="download(item?.id, item?.name)"
                      alt="Download" title="Download">
                      download
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
  <app-loading [loader]="isLoading"></app-loading>
</div>